import React from 'react';
import { useTranslation } from 'react-i18next';
import LocalizedLink from '../i18n/LocalizedLink';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-r from-gray-800 to-gray-900 text-gray-300 py-8 mt-12">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-6">
          {/* Sección de enlaces */}
          <div>
            <h3 className="text-white font-semibold mb-3 text-lg">{t('siteFooter.brand')}</h3>
            <p className="text-sm text-gray-400">
              {t('siteFooter.description')}
            </p>
          </div>

          {/* Enlaces importantes */}
          <div>
            <h4 className="text-white font-semibold mb-3">{t('siteFooter.linksTitle')}</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <LocalizedLink 
                  to="/blog" 
                  className="hover:text-blue-400 transition-colors duration-200"
                >
                  📝 {t('siteFooter.links.blog')}
                </LocalizedLink>
              </li>
              <li>
                <LocalizedLink 
                  to="/about" 
                  className="hover:text-blue-400 transition-colors duration-200"
                >
                  👥 {t('siteFooter.links.about')}
                </LocalizedLink>
              </li>
              <li>
                <LocalizedLink 
                  to="/contact" 
                  className="hover:text-blue-400 transition-colors duration-200"
                >
                  📧 {t('siteFooter.links.contact')}
                </LocalizedLink>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-semibold mb-3">{t('siteFooter.legalTitle')}</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <LocalizedLink 
                  to="/privacy-policy" 
                  className="hover:text-blue-400 transition-colors duration-200"
                >
                  🔒 {t('siteFooter.legal.privacy')}
                </LocalizedLink>
              </li>
              <li>
                <LocalizedLink 
                  to="/terms-of-service" 
                  className="hover:text-blue-400 transition-colors duration-200"
                >
                  📄 {t('siteFooter.legal.terms')}
                </LocalizedLink>
              </li>
            </ul>
          </div>

          {/* Información adicional */}
          <div>
            <h4 className="text-white font-semibold mb-3">{t('siteFooter.followTitle')}</h4>
            <p className="text-sm text-gray-400 mb-3">
              {t('siteFooter.followText')}
            </p>
            <div className="flex space-x-3">
              <a
                href="https://www.tiktok.com/@ruraylabs"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors duration-200"
                aria-label="TikTok"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.34-6.34V8.75a8.18 8.18 0 0 0 4.76 1.52V6.84a4.84 4.84 0 0 1-1-.15z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Separador */}
        <div className="border-t border-gray-700 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm">
            <p className="text-gray-400 mb-2 md:mb-0">
              © {currentYear} <span className="text-white font-semibold">RurayLabs</span>. {t('siteFooter.rightsReserved')}
            </p>
            <p className="text-gray-500 text-xs dark:text-gray-400">
              {t('siteFooter.madeWithLove')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
